<template>
  <div class="bg-base-200 mb-6">
    <div class="flex items-center justify-between p-4">
      <h1 class="text-2xl font-bold">Danh sách phiên bản</h1>
      <BaseBuildCreateModal />
    </div>
    <div class="p-4 pt-0">
      <label class="input input-bordered w-full max-w-xs">
        <i class="fa-solid fa-magnifying-glass text-base-content/80"></i>
        <input
          type="text"
          aria-label="Tìm kiếm theo phiên bản hoặc mô tả"
          placeholder="Tìm kiếm theo phiên bản hoặc mô tả..."
          :value="keyword"
          @input="handleSearch"
        />
      </label>
    </div>
    <div class="p-4 pt-0">
      <div v-if="isLoading" class="text-center">Đang tải...</div>
      <div v-else-if="error" class="text-center text-red-500">
        Lỗi: {{ error.message }}
      </div>
      <template v-else-if="baseBuildsData?.data?.length">
        <PaginationTemplate class="mb-3" :total_pages="total_pages" />
        <table class="table-zebra bg-base-100 table w-full">
          <thead>
            <tr>
              <th>Phiên bản</th>
              <th>Mô tả</th>
              <th>Ngày tạo</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in baseBuildsData.data" :key="item.id">
              <td>{{ item.version }}</td>
              <td>{{ item.description }}</td>
              <td>
                {{ dayjs(item.created).fromNow() }}
                <span class="ml-2 text-sm text-base-content/70">
                  {{ dayjs(item.created).format('YYYY-MM-DD HH:mm:ss') }}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </template>
      <div v-else class="text-center">Không có base build nào.</div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { number_from_query, str_from_query } from "@/api";
import { getBaseBuildPagination } from "@/api/basebuild";
import PaginationTemplate from "@/components/PaginationTemplate.vue";
import { router } from "@/router/router";
import { useQuery } from "@tanstack/vue-query";
import dayjs from "dayjs";
import { computed, ref } from "vue";
import BaseBuildCreateModal from "./BaseBuildCreateModal.vue";

const keyword = computed(() => str_from_query("keyword") || "");
const debounceTimer = ref<ReturnType<typeof setTimeout> | null>(null);

const handleSearch = (event: Event) => {
  const target = event.target as HTMLInputElement;
  const newKeyword = target.value;

  if (debounceTimer.value) {
    clearTimeout(debounceTimer.value);
  }

  debounceTimer.value = setTimeout(() => {
    router.push({
      query: {
        ...router.currentRoute.value.query,
        keyword: newKeyword || undefined,
        page: undefined,
      },
    });
  }, 500);
};

const page = computed(() => number_from_query("page", 1));
const size = computed(() => number_from_query("size", 10));
const queryParams = computed(() => ({
  keyword: keyword.value,
  page: page.value,
  size: size.value,
}));

const {
  data: baseBuildsData,
  isLoading,
  error,
} = useQuery({
  queryKey: ["baseBuilds", queryParams],
  queryFn: () => getBaseBuildPagination(queryParams.value),
});

const total_pages = computed(() =>
  Math.ceil((baseBuildsData.value?.total_filter || 0) / size.value),
);
</script>
